import CreativelyLogo from 'images/index/creatively.svg'
import LiveLogo from 'images/index/live.svg'
import MustardLogo from 'images/index/mustard-full.svg'

import CreativelyHero from 'images/projects/creatively/creatively-hero.avif'
import Live from 'images/projects/live/live-seo.webp'
import Mustard from 'images/projects/mustard/mustard-seo.webp'

import {
  CREATIVELY_PROJECT_ROUTE,
  MUSTARD_PROJECT_ROUTE,
  LIVE_PROJECT_ROUTE,
} from 'routes/constants'
import { FEATURED_PROJECTS } from 'components/SEM/constants'

export const SectionData = {
  type: FEATURED_PROJECTS,
  hasFooterButtonMobile: true,
  hasNoPaddingBottom: true,
  buttonText: 'Join them',
  projects: [
    {
      key: 'creatively',
      title: 'Creatively',
      description: 'The job platform for creatives',
      logo: CreativelyLogo,
      image: CreativelyHero,
      route: CREATIVELY_PROJECT_ROUTE,
    },
    {
      key: 'mustard',
      title: 'Mustard',
      description: 'Experience the next generation of motion tracking',
      logo: MustardLogo,
      image: Mustard,
      route: MUSTARD_PROJECT_ROUTE,
    },
    {
      key: 'live',
      title: 'Live',
      description: 'Experience the next generation of luxury retail',
      logo: LiveLogo,
      image: Live,
      route: LIVE_PROJECT_ROUTE,
    },
  ],
}
